<script setup lang="ts">
/**
 * 로그인 전 카드의 로고 머리(70차 UXE-16) — 로그인 · 회원가입 · 이메일 인증 · 오류 화면이 `<div class="logo">SH</div>` 를 각자 복제하던 것을 대신한다.
 * - DOM 은 그대로 `.brand > .logo + div > (h1|p) + p` 라 main.scss 공용 규칙(카드 첫 요소 여백 · 구분선 · 부제 12/500 회색)이 그대로 걸린다.
 *   카드(`.auth-card > .card` · `.ui-public-card`)의 **첫 요소**로 둔다.
 * - 로고 글자 「SH」 는 제품 표지일 뿐이라 늘 `aria-hidden` — 화면 읽기는 제목부터 읽는다.
 * - `as="p"`(오류 화면)는 제품명이 페이지 제목(h2)보다 위 계층이 아니라서 h1 대신 문단으로 두고, 모양만 h1 과 같게 맞춘다
 *   (줄 높이가 다르면 머리 높이가 4px 달라 두 화면의 구분선이 어긋났다 — ErrorLayout 의 같은 규칙을 여기로 옮겼다).
 * - 공개 링크 화면(채용 지원 · 입사서류 · 직무 입력)은 회사 · 직무가 주인공이라 이 부품 대신 `PublicShell` 머리를 쓴다.
 */
withDefaults(
  defineProps<{
    /** 제목(제품명 · 화면 이름) */
    title: string;
    /** 제목 아래 한 줄 */
    subtitle?: string;
    /** 제목 요소. 오류 레이아웃은 "p"(제품명) */
    as?: "h1" | "p";
  }>(),
  { subtitle: undefined, as: "h1" },
);
</script>

<template>
  <div class="brand">
    <div class="logo" aria-hidden="true">SH</div>
    <div>
      <h1 v-if="as === 'h1'">{{ title }}</h1>
      <!-- `error-brand-name` 은 main.scss 의 부제 규칙(12/500 회색)에서 빠지는 표지다 -->
      <p v-else class="error-brand-name brand-header-name">
        <span>{{ title }}</span>
      </p>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<style scoped>
/* 인증 화면 로고 머리 제목(프로토타입 `.brand h1` 20px · 줄 높이 31px · #0f172a)과 같은 모양.
   프로토타입 `.brand p{color · font-size:11px · font-weight:800 · line-height:1.35 — 모두 !important}`(base.scss) 가 문단을 잡고 있어
   모양은 문단이 아니라 안쪽 span 이 블록으로 직접 갖는다(span 은 `.brand p` 에 걸리지 않아 !important 없이 이긴다). 문단은 여백만 걷는다. */
.brand-header-name {
  margin: 0;
}

.brand-header-name > span {
  display: block;
  color: var(--ui-text);
  font-size: var(--ui-fs-xl);
  font-weight: var(--ui-fw-black);
  line-height: 31px; /* 인증 화면 h1 실측 줄 높이(20px × 본문 1.55) — 스케일 값이 아니라 두 머리의 구분선 높이를 맞추는 값 */
  letter-spacing: -0.06em;
}
</style>
